import { z } from "zod/v4";

import {
  CartTransformFeaturesSchema,
  CartTransformSchema,
} from "../../../schemas/organization";

export const GetCartTransformResponseBodySchema = z.object({
  cartTransforms: CartTransformSchema.array(),
  cartTransformFeatures: CartTransformFeaturesSchema,
});

export type GetCartTransformResponseBodyType = z.infer<
  typeof GetCartTransformResponseBodySchema
>;
